import { Rating } from "@mui/material";
import React from "react";

const AppRating = ({ rating }) => {
    return (
        <React.Fragment>
            <Rating
                name="half-rating-read"
                value={rating || 0}
                readOnly sx={{ color: '#101010' }}
                precision={0.5}
                emptyIcon={<i className="ri-star-fill" style={{ fontSize: 22, marginTop: -5.5 }} />}
            />
        </React.Fragment>
    );
};

export default AppRating;